import React, { useEffect, useState } from "react";
import ImageLogo from "components/utility/images/ImageLogo";
import { changeCountry } from "components/public-site/audience-sort/utility/audienceSortApiHandlers";
import { SCREEN_WIDTHS } from "components/utility/constants/screen_widths";
import { LocationChangeCTA } from "components/public-site/audience-sort/LocationChangeCTA";

const SplashHeader = ({ globalSplashProps = {} }) => {
	const [isMobileXS, setIsMobileXS] = useState(window.innerWidth <= SCREEN_WIDTHS.XS);
	useEffect(() => {
		const isMobileFunc = () => {
			setIsMobileXS(window.innerWidth <= SCREEN_WIDTHS.XS);
		};
		window.addEventListener("resize", isMobileFunc);
		return () => {
			window.removeEventListener("resize", isMobileFunc);
		};
	}, []);

	const locationChangeEventHandler = async (event) => {
		if (!globalSplashProps.countryListData) {
			await changeCountry(
				event,
				globalSplashProps.initialData,
				globalSplashProps.setCountryListData
			);
		}
		globalSplashProps.setStep("display-country-selection");
		globalSplashProps.setIsModalOpen(true);
	};

	return (
		<div className="public-global-splash-home-header">
			<div className="public-global-splash-logo">
				<ImageLogo />
			</div>
			{globalSplashProps.initialData && !isMobileXS && (
				<LocationChangeCTA
					countryName={globalSplashProps.initialData.countryName}
					locationChangeText={globalSplashProps.initialData.locationChangeText}
					eventHandler={locationChangeEventHandler}
				/>
			)}
		</div>
	);
};

export default SplashHeader;
